import {
  ACCOMMODATION_FORMS_NUMBERS,
  ACCOMMODATION_FORMS_ORDER
} from 'pages/create-accommodation/constants';

export const isAccommodationFormDone = (
  formName,
  languages,
  forms,
  savedForms,
  activeTab,
  scheduleActiveSubTab,
  pricesActiveSubTab
) => {
  if (formName === 'generalForm' || formName === 'descriptionForm') {
    if (languages.length > 1) {
      const formNameSecondLanguage = `${formName}-Norwegian`;
      if (
        !forms[formNameSecondLanguage] ||
        forms[formNameSecondLanguage].syncErrors ||
        !savedForms[formNameSecondLanguage] ||
        !Object.keys(savedForms[formNameSecondLanguage]).length
      ) {
        return false;
      }
    }
  }

  if (formName === 'pricesForm') {
    if (!forms['generalForm']) return false;
    if (!savedForms.pricesTab) return false;
    const pricesFormName =
      ACCOMMODATION_FORMS_ORDER[ACCOMMODATION_FORMS_NUMBERS.pricesForm][
        pricesActiveSubTab
      ];
    if (
      !forms[pricesFormName] ||
      forms[pricesFormName].syncErrors ||
      !savedForms[pricesFormName]
    ) {
      return false;
    }
    return true;
  }

  if (!forms[formName] || forms[formName].syncErrors || !savedForms[formName]) {
    return false;
  }

  return true;
};
